import  Url  from "../../address";

const addressSignIn = Url + "/user/sign_in";
const addressSignUp = Url + "/user/sign_up";
const addressSignOut = Url + "/user/sign_out";
const addressCheckSession = Url + "/user/check_session";

export default { addressSignIn, addressSignUp, addressSignOut, addressCheckSession };
